import { render, staticRenderFns } from "./ListContainer.vue?vue&type=template&id=356e96f8"
import script from "./ListContainer.vue?vue&type=script&lang=js"
export * from "./ListContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports